// Display names for recharge_history.recharge_type values.
const PROVIDER_LABELS = {
  vrplay: "VRPlay",
  watcho: "Watcho",
  etvwin: "ETV Win",
  pioneeriptv: "Pioneer IPTV",
  playboxtv: "Playbox TV",
  antiptv: "Antiptv",
  ottplay: "OTTPlay",
  internet: "Pioneer",
  dvpl: "DVPL",
  railtel: "RailTel",
  combo: "Combo",
};

export const providerLabel = (type) =>
  !type ? "" : PROVIDER_LABELS[String(type).toLowerCase()] || String(type);

/** Customer-page tab for a recharge type (see Customer/index.js providerTabs). */
export const providerTab = (type) => {
  const t = String(type || "").toLowerCase();
  return ["vrplay", "watcho", "etvwin", "pioneeriptv", "playboxtv", "antiptv", "internet", "dvpl", "railtel", "combo"].includes(t)
    ? t
    : "transactions";
};

/** ₹1,23,456.50 */
export const formatRupees = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "₹0";
  return "₹" + n.toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
};

/** "01 Oct 2026, 03:45 pm" from an ISO string or "YYYY-MM-DD HH:MM:SS". */
export const formatDateTime = (value) => {
  if (!value) return "—";
  const d = new Date(String(value).includes("T") ? value : String(value).replace(" ", "T"));
  if (Number.isNaN(d.getTime())) return String(value);
  return d.toLocaleString("en-IN", {
    day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true,
  });
};
